/**
 * Concatena classes, mantendo só as strings não vazias.
 *
 * Não é `clsx` nem `tailwind-merge`: o design system não depende de precedência
 * mágica de classes utilitárias porque cada componente expõe `variante`/`tamanho`
 * e recebe `className` **por último** — quem chama sobrepõe pela ordem, que é o
 * comportamento que o CSS já garante para especificidade igual.
 *
 * O parâmetro é `unknown` de propósito. O idioma `condicao && 'classe'` é usado em
 * todo componente, e quando `condicao` é um `ReactNode` (o caso de
 * `descricao && 'mt-1'`) o tipo resultante inclui número e elemento. Restringir a
 * assinatura obrigaria um `Boolean(...)` em cada uso, sem ganho: o filtro abaixo
 * descarta qualquer coisa que não seja texto de classe.
 */
export type ValorClasse = unknown

export function cn(...valores: ValorClasse[]): string {
  return valores
    .filter((valor): valor is string => typeof valor === 'string' && valor.length > 0)
    .join(' ')
}
